<template>
  <b-row>
    <b-col cols="auto">
      <b-button :variant="buttonVariant" :class="buttonClass" @click.stop="$emit('click')">
        {{ buttonWording }}
      </b-button>

      <BaseTagSubmissionStatus :status="currentStatus" class="mx-3" />
    </b-col>
  </b-row>
</template>

<script>
import Status from '@/models/Status';
import { assessmentStatusMixin } from '@/mixins/assessmentStatusMixin';
import BaseTagSubmissionStatus from '@/components/base-components/BaseTagSubmissionStatus';

export default {
  components: { BaseTagSubmissionStatus },
  mixins: [assessmentStatusMixin],

  computed: {
    shouldSeeFeedback() {
      return this.currentStatus
        ? this.currentStatus.name === Status.REVIEW_PENDING ||
            this.currentStatus.name === Status.PASSED
        : false;
    },

    buttonVariant() {
      return this.shouldSeeFeedback ? 'outline-primary' : 'primary';
    },

    buttonWording() {
      return this.shouldSeeFeedback ? 'View feedback' : 'Response';
    },

    buttonClass() {
      return {
        'btn__view-response': !this.shouldSeeFeedback,
        'btn__view-feedback': this.shouldSeeFeedback
      };
    }
  }
};
</script>
